import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState, PlatformEnum, PlatformService } from '@panamax/app-state';
import { ImageVariantEnum } from '@product-detail/models/image-variant.enum';
import {
  getAlternativeThumbnail,
  getFirstImageURL,
} from '@product-detail/utils/product-images.util';
import { QuantityUpdate } from '@shared/models/quantity-update';
import { Order, OrderItemState } from '@usf/ngrx-order';
import { ProductPropertiesEnum } from '@usf/product-types';
import { Product } from '@shared/models/product.model';
import { FEATURES } from '@shared/constants/splitio-features';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';
import { TagProduct } from '@shared/components/usf-product-tag-list/models/tag-product.model';
import { Observable } from 'rxjs';

@Component({
  template: '',
})
export class OrderInsightsProductBaseComponent implements OnInit {
  @Input() product: Product;
  @Input() isDyfNotOrderedProduct: boolean;
  @Input() lastOrderedDate: string | Date;
  @Input() lastOrderedQuantity: string;
  @Output() handleClick: EventEmitter<any> = new EventEmitter();
  @Input() order: Order;
  @Input() isOnline: boolean;
  @Input() orderItems: OrderItemState;
  @Output() quantityUpdateEmitter = new EventEmitter<QuantityUpdate>();
  @Input() newProductOrdered: boolean;

  thumbnailImageURL: string;
  readonly PlatformEnum = PlatformEnum;
  readonly propertiesEnum = ProductPropertiesEnum;
  lostLineAddToOrderFeatureFlag =
    FEATURES.split_global_order_add_lost_line.name;
  offlineQtyBoxEnableFlag$: Observable<boolean>;

  constructor(
    readonly platformService: PlatformService,
    readonly translateService: TranslateService,
    readonly panAppState: PanAppState,
  ) {}

  ngOnInit(): void {
    this.thumbnailImageURL = getFirstImageURL(
      this.product?.summary,
      ImageVariantEnum.Thumbnail,
    );
    this.offlineQtyBoxEnableFlag$ = this.panAppState.feature$([
      FEATURES.split_global_offline_update_quantities.name,
    ]);
  }

  getAlternativeThumbnail = (thumbnailImageURL: string): string =>
    getAlternativeThumbnail(this.product?.summary, thumbnailImageURL);

  handleProductCardClick(event) {
    this.handleClick.emit();
  }

  changeQuantityHandler(quantityUpdate: QuantityUpdate) {
    this.quantityUpdateEmitter.emit(quantityUpdate);
  }

  transformProductToProductDetail() {
    return {
      ...this.product,
    } as ProductDetailViewModel;
  }
}
